
  var _styles = {
  "double-card-container-double": {
    "fontFamily": "PingFang SC",
    "width": "4.6rem",
    "height": "6.49333rem",
    "marginBottom": "0.16rem",
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "double-card-image-view": {
    "width": "100%",
    "height": "3.44rem",
    "overflow": "hidden",
    "borderRadius": "0.24rem 0.24rem 0 0"
  },
  "double-tag-container": {
    "position": "absolute",
    "left": "-0.05333rem",
    "top": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-tag-container-relative": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "width": "4.6rem"
  },
  "double-tag-container-tags": {
    "height": "0.48rem",
    "zIndex": 9
  },
  "double-tag-content": {
    "height": "0.42667rem",
    "padding": "0.08rem",
    "borderTopLeftRadius": "0.16rem",
    "borderBottomRightRadius": "0.16rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "rgb(255,209,0)"
  },
  "double-tag-text": {
    "height": "0.26667rem",
    "fontSize": "0.26667rem",
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "lineHeight": "0.26667rem",
    "whiteSpace": "nowrap",
    "color": "rgb(34,34,34)"
  },
  "double-tag-triangle": {
    "position": "absolute",
    "left": 0,
    "bottom": "-0.08rem",
    "width": 0,
    "height": 0,
    "borderLeftWidth": "0.08rem",
    "borderLeftStyle": "solid",
    "borderLeftColor": "rgba(0,0,0,0)",
    "borderRightWidth": 0,
    "borderRightStyle": 0,
    "borderRightColor": 0,
    "borderTopWidth": "0.08rem",
    "borderTopStyle": "solid",
    "borderTopColor": "rgb(255,209,0)"
  },
  "double-tag-triangle-mrn-wrap": {
    "position": "absolute",
    "left": 0,
    "top": "0.37333rem",
    "width": "0.08rem",
    "height": "0.08rem",
    "overflow": "hidden"
  },
  "double-tag-triangle-mrn": {
    "width": "0.10667rem",
    "height": "0.10667rem",
    "backgroundColor": "rgb(255,209,0)",
    "transform": "rotate(45deg)",
    "marginLeft": "-0.08rem",
    "marginTop": "0.02667rem"
  },
  "double-card-image": {
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.24rem 0.24rem 0 0",
    "OObjectFit": "cover",
    "objectFit": "cover"
  },
  "double-card-image-tag": {
    "position": "absolute",
    "width": "0.96rem",
    "height": "0.48rem",
    "top": 0,
    "left": "-0.05333rem",
    "zIndex": 9
  },
  "double-departures-dev": {
    "height": "0.42667rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "backgroundColor": "rgba(0,0,0,0.6)",
    "borderTopLeftRadius": "0.21333rem",
    "borderBottomRightRadius": "0.21333rem",
    "paddingBottom": "0.08rem",
    "paddingTop": "0.08rem",
    "paddingRight": "0.08rem",
    "zIndex": 8
  },
  "double-departures-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "paddingLeft": "0.12rem",
    "paddingRight": "0.13333rem"
  },
  "double-rate-location-box-container": {
    "height": "0.32rem",
    "position": "absolute",
    "left": "0.16rem",
    "top": "2.81333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "double-rate-container": {
    "height": "0.26667rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "double-rate-score": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFang SC",
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "marginRight": "0.08rem"
  },
  "double-rate-count": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFang SC",
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "marginRight": "0.08rem"
  },
  "double-location-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-location-text": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFang SC",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  },
  "double-card-content-right": {
    "flex": 1,
    "width": "100%",
    "height": "3.05333rem",
    "paddingTop": "0.16rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.16rem",
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column"
  },
  "double-card-top-field": {
    "width": "100%",
    "display": "flex"
  },
  "double-card-tag-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.02667rem"
  },
  "double-card-day-tag": {
    "borderTopLeftRadius": "0.08rem",
    "borderTopRightRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "borderBottomRightRadius": "0.08rem",
    "overflow": "hidden",
    "width": "0.42667rem",
    "maxWidth": "0.42667rem",
    "height": "0.42667rem",
    "marginRight": "0.06667rem"
  },
  "double-card-day-tag-text": {
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "backgroundColor": "rgb(255,209,0)"
  },
  "double-card-deal-name": {
    "position": "relative",
    "fontSize": "0.37333rem",
    "width": "4.26667rem",
    "lineHeight": "0.53333rem",
    "textAlign": "left",
    "verticalAlign": "bottom"
  },
  "double-card-day-h5-tag-view": {
    "position": "absolute",
    "top": "0.06667rem",
    "left": 0,
    "height": "0.37333rem",
    "borderRadius": "0.08rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.08rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-day-h5-tag-text": {
    "color": "rgb(34,0,0)",
    "lineHeight": "0.26667rem",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "height": "0.37333rem"
  },
  "double-card-deal-name-text": {
    "fontFamily": "PingFang SC",
    "lineHeight": "0.53333rem",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,33)",
    "fontWeight": "500"
  },
  "double-card-tag": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.16rem",
    "marginRight": 0,
    "marginBottom": "0.13333rem",
    "marginLeft": 0,
    "height": "0.37333rem"
  },
  "double-card-product-tag-group": {
    "height": "0.37333rem",
    "boxSizing": "border-box",
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)",
    "marginRight": "0.08rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-product-tag-text-group": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem"
  },
  "double-card-people-tag": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(142,60,18,0.2980392157)",
    "marginRight": "0.08rem",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-people-tag-text": {
    "color": "rgb(142,60,18)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "double-card-product-tag-free": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(7,119,238,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-product-tag-text-free": {
    "color": "rgb(7,119,238)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "double-card-bottom-field": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "space-between",
    "flex": 1,
    "width": "100%",
    "height": "0.93333rem"
  },
  "double-card-bottom-left-field": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "double-card-price-now": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "color": "rgb(255,39,39)",
    "fontWeight": "600",
    "fontSize": "0.48rem"
  },
  "double-card-price-icon": {
    "fontSize": "0.32rem",
    "fontWeight": "600",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC"
  },
  "double-card-price-price": {
    "height": "0.66667rem",
    "fontSize": "0.48rem",
    "fontWeight": "700",
    "color": "rgb(255,39,39)",
    "marginRight": "0.02667rem",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "double-card-price-text-piece": {
    "color": "rgb(102,102,102)",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "marginRight": "0.05333rem"
  },
  "double-card-price-start": {
    "color": "rgb(102,102,102)",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "marginRight": "0.05333rem",
    "marginLeft": "-0.08rem",
    "marginBottom": "0.02667rem"
  },
  "double-card-discount-container": {
    "marginTop": "-0.05333rem",
    "height": "0.37333rem"
  },
  "double-card-bg-color-container-2": {
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,190,143)",
    "borderRadius": "0.08rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-text-3": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "fontWeight": "400"
  },
  "double-card-price-origin": {
    "color": "rgb(102,102,102)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "textDecoration": "line-through"
  },
  "double-card-discount-width-field": {
    "height": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-card-discount-left-field": {
    "alignSelf": "flex-start",
    "borderTopLeftRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "lineHeight": "0.37333rem",
    "height": "100%"
  },
  "double-card-discount-img": {
    "height": "0.37333rem",
    "width": "0.37333rem"
  },
  "double-card-discount-width-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "paddingBottom": "0.02rem",
    "marginRight": "0.02667rem"
  },
  "double-card-discount-right-field": {
    "height": "0.37333rem",
    "display": "flex",
    "alignSelf": "flex-start",
    "flexDirection": "row",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "borderRadius": "0 0.08rem 0.08rem 0"
  },
  "double-card-curve-img": {
    "height": "0.37333rem",
    "width": "0.10667rem",
    "marginLeft": "-0.02667rem"
  },
  "double-card-reduce-text": {
    "lineHeight": "0.37333rem",
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "color": "rgb(255,75,16)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginRight": "0.08rem"
  },
  "double-card-discount-field": {
    "height": "0.37333rem",
    "marginTop": "-0.04rem",
    "display": "flex",
    "flexDirection": "row",
    "alignSelf": "flex-start",
    "borderRadius": "0.08rem"
  },
  "double-card-discount-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem",
    "marginTop": "0.01333rem"
  },
  "double-card-bottom-right-field": {
    "borderRadius": "0.4rem",
    "height": "0.8rem",
    "width": "1.38667rem",
    "backgroundColor": "rgba(7,119,238,0.5411764706)",
    "position": "absolute",
    "right": "0.16rem",
    "bottom": 0,
    "overflow": "hidden"
  },
  "double-card-bottom-right-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "600",
    "fontSize": "0.37333rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https: //s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  